const contentSectionStyles = {
  reverse: {
    textAlign: "end",
  },
  imageBox: (theme) => ({
    [theme.breakpoints.down("lg")]: {
      justifyContent: "center",
    },
  }),
};

export default contentSectionStyles;
